export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";